module.exports = __webpack_public_path__ + "static/media/logo.624650c5.png";